import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import {
  useNavigate,
} from 'react-router-dom';

import {
  Box,
  Button,
  KeyIcon,
  Stack,
  styled,
  Typography,
} from '@datanomik/commons-ui';

import { BugLine } from '@datanomik/commons-ui/icons';

import { styles } from './styles';

const ErrorPageRaw = ({ className }) => {
  const navigateRedirect = useNavigate();

  const handleClick = () => {
    navigateRedirect('/');
  };

  return (
    <Box className={className}>
      <Stack
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        gap="15px"
      >
        <KeyIcon size="xxlarge" color="red">
          <BugLine />
        </KeyIcon>
        <Typography variant="p3">{t('Something went wrong!')}</Typography>

        <Button onClick={handleClick}>{t('Back to home page')}</Button>
      </Stack>
    </Box>
  );
};

ErrorPageRaw.propTypes = {
  className: PropTypes.string,
};

export const ErrorPage = styled(ErrorPageRaw)(styles);
ErrorPage.propTypes = ErrorPageRaw.propTypes;
